import script from "./MapDistanceBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./MapDistanceBlock.vue?vue&type=script&setup=true&lang=js"

import "./MapDistanceBlock.vue?vue&type=style&index=0&id=04dbaf7c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04dbaf7c"]])

export default __exports__